import React, { useEffect } from 'react';
import { Check, X } from 'lucide-react';
import { Store } from '../../types';
import confetti from 'canvas-confetti';
interface CheckInSuccessScreenProps {
  store: Store;
  onDismiss: () => void;
}
export function CheckInSuccessScreen({
  store,
  onDismiss
}: CheckInSuccessScreenProps) {
  useEffect(() => {
    const duration = 3000;
    const end = Date.now() + duration;
    const frame = () => {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        },
        colors: ['#A020F0', '#FFFC00']
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        },
        colors: ['#A020F0', '#FFFC00']
      });
      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };
    frame();
  }, []);
  return <div className="fixed inset-0 z-50 bg-purple-600 flex flex-col items-center justify-center p-6 text-white animate-in zoom-in duration-300" data-id="element-92">
      <button onClick={onDismiss} className="absolute top-6 right-6 p-2 bg-white/20 rounded-full hover:bg-white/30 transition-colors" data-id="element-93">
        <X size={24} data-id="element-94" />
      </button>

      <div className="w-32 h-32 bg-white rounded-3xl p-2 mb-8 shadow-2xl rotate-3" data-id="element-95">
        <img src={store.image} alt="" className="w-full h-full object-cover rounded-2xl" data-id="element-96" />
      </div>

      <h1 className="text-4xl font-bold mb-2 text-center" data-id="element-97">Checked In!</h1>
      <p className="text-purple-200 text-lg mb-8 text-center" data-id="element-98">
        at {store.name}
      </p>

      <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 w-full max-w-xs text-center border border-white/20" data-id="element-99">
        <p className="text-sm font-bold uppercase tracking-wider text-purple-200 mb-2" data-id="element-100">
          Points Earned
        </p>
        <p className="text-5xl font-bold text-[#FFFC00]" data-id="element-101">+50</p>
      </div>

      <div className="mt-12 flex gap-2" data-id="element-102">
        {[1, 2, 3].map(i => <div key={i} className="w-3 h-3 rounded-full bg-white/30 animate-bounce" style={{
        animationDelay: `${i * 100}ms`
      }} data-id="element-103" />)}
      </div>
    </div>;
}